"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateProfessionalExperienceDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
class UpdateProfessionalExperienceDto {
}
exports.UpdateProfessionalExperienceDto = UpdateProfessionalExperienceDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "ID of the professional experience",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], UpdateProfessionalExperienceDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Contact ID associated with the professional experience",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Contact ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateProfessionalExperienceDto.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "From date of the professional experience",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)({ message: "From date must be a valid date" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], UpdateProfessionalExperienceDto.prototype, "fromDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "To date of the professional experience",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)({ message: "To date must be a valid date" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], UpdateProfessionalExperienceDto.prototype, "toDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Company name", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Company name must be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Company name must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateProfessionalExperienceDto.prototype, "company", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Designation in the company", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Designation must be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Designation must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateProfessionalExperienceDto.prototype, "designation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Department in the company", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Department must be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Department must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateProfessionalExperienceDto.prototype, "department", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Details of the professional experience",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Details must be a string" }),
    (0, class_validator_1.MaxLength)(500, { message: "Details must not exceed 500 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateProfessionalExperienceDto.prototype, "details", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Created by", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateProfessionalExperienceDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Updated by", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateProfessionalExperienceDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Created at", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], UpdateProfessionalExperienceDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Updated at", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], UpdateProfessionalExperienceDto.prototype, "updatedAt", void 0);
